module.exports = __webpack_public_path__ + "img/salon-2017.6b7e41db.jpg";